export default "__VITE_ASSET__DP8zYTch__"